import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { Divider } from '@grandvisionhq/elements';
import { useDispatchTrackEvent } from '@grandvisionhq/svc-tealium/events';
import { isFunction } from '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import { CartProvider } from '../../../context/Cart/provider.js';
import '../../../context/CartSettings/context.js';
import '@swc/helpers';
import { mapVisualLineItemProductToTealiumProduct } from '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import { CartTotals } from '../components/CartTotals.js';
import { ActionButtonsContainer } from '../containers/ActionButtonsContainer.js';
import { LineItemsContainer } from '../containers/LineItemsContainer.js';
import { SuccessNotificationContainer } from '../containers/SuccessNotificationContainer.js';
import { TitleContainer } from '../containers/TitleContainer.js';

const classPrefix = 'mini-cart-v2';
const MiniCart = ({ alerts =[] , children , components ={} , links , lineItems ,  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const dispatchTrackEvent = useDispatchTrackEvent();
    const Components = React.useMemo(()=>({
            ActionButtons: components.ActionButtons || ActionButtonsContainer,
            CartTotals: components.CartTotals || CartTotals,
            LineItems: components.LineItems || LineItemsContainer,
            SuccessNotification: components.SuccessNotification || SuccessNotificationContainer,
            Title: components.Title || TitleContainer
        })
    , [
        components
    ]);
    React.useEffect(()=>{
        dispatchTrackEvent(()=>Promise.resolve({
                id: 'Impression',
                Page_Section2: 'MiniCart',
                Products: mapVisualLineItemProductToTealiumProduct(lineItems, true)
            })
        );
    // This event need to be fired only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const HorizontalDivider = /*#__PURE__*/ React.createElement(Divider, {
        className: `${classPrefix}__divider`,
        orientation: "horizontal",
        theme: "light"
    });
    const childrenRenderResult = children && isFunction(children) ? children(lineItems) : children;
    if (isSmallScreen) {
        return /*#__PURE__*/ React.createElement(CartProvider, null, /*#__PURE__*/ React.createElement("div", {
            className: `${classPrefix}__container`
        }, /*#__PURE__*/ React.createElement(Components.Title, null), HorizontalDivider, /*#__PURE__*/ React.createElement(Components.SuccessNotification, null), /*#__PURE__*/ React.createElement("div", {
            className: `${classPrefix}__lineItems`
        }, /*#__PURE__*/ React.createElement(Components.LineItems, {
            lineItems: lineItems
        })), HorizontalDivider, /*#__PURE__*/ React.createElement(Components.CartTotals, {
            isMiniCart: true
        }), /*#__PURE__*/ React.createElement(Components.ActionButtons, {
            links: links
        }), alerts.length ? /*#__PURE__*/ React.createElement("div", {
            className: `${classPrefix}__alerts`
        }, alerts) : null), /*#__PURE__*/ React.createElement("div", {
            className: `${classPrefix}__recommendation`
        }, childrenRenderResult));
    }
    return /*#__PURE__*/ React.createElement(CartProvider, null, /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__container`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__box`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__added-item`
    }, /*#__PURE__*/ React.createElement(Components.SuccessNotification, null), /*#__PURE__*/ React.createElement(Components.LineItems, {
        lineItems: lineItems
    }))), /*#__PURE__*/ React.createElement(Divider, {
        className: `${classPrefix}__divider--vertical`,
        orientation: "vertical",
        theme: "light"
    }), /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__box`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__basket`
    }, /*#__PURE__*/ React.createElement(Components.Title, null), HorizontalDivider, /*#__PURE__*/ React.createElement(Components.CartTotals, {
        isMiniCart: true
    }), HorizontalDivider, /*#__PURE__*/ React.createElement(Components.ActionButtons, {
        links: links
    }))), childrenRenderResult && /*#__PURE__*/ React.createElement(Divider, {
        className: `${classPrefix}__divider`,
        orientation: "horizontal",
        theme: "light"
    }), alerts.length ? /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__alerts`
    }, alerts) : null), /*#__PURE__*/ React.createElement("div", {
        className: `${classPrefix}__recommendation`
    }, childrenRenderResult));
};

export { MiniCart };
//# sourceMappingURL=MiniCart.js.map
